import GridViewCollapase from "src/SharedComponents/GridViewCollapse/GridViewCollapse";
import tableStyles from 'src/Utils/CssModules/table.module.css';
import { IAuraSoftwareSuiteLicensesInfo, IUserLicencesInfo } from "src/Utils/Hooks/useGetAdminInfo/useGetAuraSupportInfo";
import { formatDateString } from "src/Utils/DateFormatting/DateFormatter";
import { isDateExpired } from "src/Utils/DateExpiry/DateExpiryChecker";
import Button from "src/SharedComponents/Button/Button";
import UnassignLicenseFromPartner from "../../UnassignLicenseFromPartner/UnassignLicenseFromPartner";
import { useState } from "react";
import TrialOrDemoHandler from "../../DemoTrialLicense/TrialOrDemoHandler";
import { useSupportPermissions } from "src/Utils/Hooks/useGetAdminInfo/useSupportPermissions";

export interface IAuraAppLicensesAssigned{
    auraAppLicensesAssigned: IUserLicencesInfo[];
    updateLicenses: () => void;
    otherLicenses: IAuraSoftwareSuiteLicensesInfo[];
}

const AuraAppLicensesAssigned: React.FC<IAuraAppLicensesAssigned> = ({auraAppLicensesAssigned, updateLicenses, otherLicenses}) => {
    const [showUnassignLicenseConfirmDialog, setshowUnassignLicenseConfirmDialog] = useState<boolean>(false);
    const { isSupportAdmin } = useSupportPermissions();
    const [entitlementId, setEntitlementId] = useState<string>("");
    const [distributorId, setDistributorId] = useState<string>("");
    const [distributorName, setDistributorName] = useState<string>("");

    const isEntitlementIdInOtherLicenses = (id: string): boolean => {
        return otherLicenses.some((license) => license.entitlementId === id);
    };

    const isDemoOrTrial = (licenseType: string) => licenseType.toLowerCase().includes("trial") || licenseType.toLowerCase().includes("demo");

    return(
        <>
            {showUnassignLicenseConfirmDialog &&
                <UnassignLicenseFromPartner
                    entitlementId={entitlementId}
                    distributorId={distributorId}
                    distributorName={distributorName}
                    closeDialog={() => setshowUnassignLicenseConfirmDialog(false)}
                    updateLicenses={updateLicenses}
                />
            }
            <GridViewCollapase title="Assigned" id="aura-app-licenses-assigned">
                <div>
                    <table style={{ width: '100%' }} data-testid="table" className={`table ${tableStyles.tableStriped}`}>
                        <thead className={`${tableStyles.tableHead}`}>
                            <tr key={'header'}>
                                <th className={tableStyles.heading} style={{width: '20%', paddingTop: '0px'}}>License Type</th>
                                <th className={tableStyles.heading} style={{width: '20%', paddingTop: '0px'}}>Expiration date</th>
                                <th className={tableStyles.heading} style={{width: '20%', paddingTop: '0px'}}>Seats</th>
                                <th className={tableStyles.heading} style={{width: '20%', paddingTop: '0px'}}>Partner</th>
                                <th className={tableStyles.heading} style={{width: '20%', paddingTop: '0px'}}>Clinic</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                auraAppLicensesAssigned.map((license: IUserLicencesInfo, index: number) => (
                                    <tr key={index}>
                                        <td className={tableStyles.data}>{license?.licenseType}</td>
                                        <td className={tableStyles.data} style={isDateExpired(license?.licenseEndDate) ? {color: 'red'} : {}}>{license?.licenseType.toLowerCase().includes("permanent") ? '-' : (license?.licenseEndDate ? formatDateString(license?.licenseEndDate) : '-')}</td>
                                        <td className={tableStyles.data}>{license?.maximumSeats}</td>
                                        <td className={tableStyles.data}>{license?.distributorName}</td>
                                        <td className={tableStyles.data}>{license?.clinicName ?? '-'}</td>
                                        {
                                            isDemoOrTrial(license.licenseType) && (license.clinicName == null) ? 
                                            <td className={tableStyles.data} style={{ display: 'flex', justifyContent: 'end' }}>
                                                <TrialOrDemoHandler EntitlementId={license.entitlementId} ClinicId={license.clinicId} ClinicName={license.clinicName} DistributorId={license.distributorId} DistributorName={license.distributorName} LicenseType={license.licenseType} updatedLicenses={updateLicenses}></TrialOrDemoHandler>
                                                </td> :
                                            <td className={tableStyles.data} style={{textAlign: 'end'}}>
                                            <Button
                                                    backgroundColor="#fff"
                                                    color="var(--primary-color)"
                                                    text="Unassign"
                                                    borderColor="var(--primary-translucent)"
                                                    fontSize="12px"
                                                    width='172px'
                                                    borderStyle='solid'
                                                    borderWidth='2px'
                                                    fontWeight='600'
                                                    disable={!isSupportAdmin || isEntitlementIdInOtherLicenses(license?.entitlementId)}
                                                    onClick={() => {
                                                        setshowUnassignLicenseConfirmDialog(true); 
                                                        setEntitlementId(license?.entitlementId);
                                                        setDistributorId(license?.distributorId);
                                                        setDistributorName(license?.distributorName);
                                                    }}
                                                />
                                        </td>
                                        }
                                    </tr>
                                ))
                            }
                        </tbody>
                    </table>
                </div>
            </GridViewCollapase>
        </>
    );
}

export default AuraAppLicensesAssigned;